import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Course_setBasicInformation($course: [CourseInformation]) {
    Course_setBasicInformation(course: $course) {
      id
    }
  }
`;

const buildCourseInput = course => ({
  id: course?.id,
  name: course?.name,
  category: course?.category,
  description: course?.description,
  trainingHours: course?.trainingHours,
  priority: course?.priority,
  expirationRule: course?.expirationRule ?? null,
  dueAmount: course?.dueAmount ?? null,
  dueUnit: course?.dueUnit ?? null,
  thumbnail: course?.thumbnail,
  terminals: course?.terminals,
});

const courseSetBasicInformation = async course =>
  graphql(mutation, { course: buildCourseInput(course) })
    .then(data => data.Course_setBasicInformation)
    .catch(e => e);

export default courseSetBasicInformation;
